export interface TeamRequest {
  created_at: number;
  request_status: RequestStatus;
  request_type: string;
  request_number: number;
  team_id: string;
  request_id: string;
}

export interface TeamRequestInfo {
  created_at: number;
  request_status: RequestStatus;
  request_type: string;
  request_number: number;
  team_id: string;
  request_id: string;
  driver: string;
  guard: string;
  intern: string;
  crew_photos: string[];
  special_equipment: string[];
  commentary?: string;
  team_name: string;
  car_service?: boolean;
  car_photos: string[];
  car_interior_photos: string[];
  liquid_cooling_level_photos: string[];
  oil_level_photos: string[];
  odometer_photos: string[];
  resolved_at?: number;
  planned_start: number;
  planned_end: number;
  service_description?: string;
}

export interface TeamShiftInfo {
  created_at: number;
  request_status: RequestStatus;
  request_type: string;
  request_number: number;
  team_id: string;
  request_id: string;
  old_driver: string;
  old_guard: string;
  old_intern: string;
  new_driver: string;
  new_guard: string;
  new_intern: string;
  old_photos: {
    special_equipment: string[];
    crew_photos: string[];
    car_photos: string[];
    car_interior_photos: string[];
    liquid_cooling_level_photos: string[];
    oil_level_photos: string[];
    odometer_photos: string[];
  };
  new_photos: {
    special_equipment: string[];
    crew_photos: string[];
    car_photos: string[];
    car_interior_photos: string[];
    liquid_cooling_level_photos: string[];
    oil_level_photos: string[];
    odometer_photos: string[];
  };
  commentary?: string;
  team_name: string;
  car_service?: boolean;
  resolved_at?: number;
  planned_start: number;
  planned_end: number;
  service_description?: string;
}

export enum RequestStatus {
  Approved = 'Approved',
  Canceled = 'Canceled',
  Pending = 'Pending',
  Declined = 'Declined',
  AutomaticallyApproved = 'AutomaticallyApproved',
}
